import React from "react";
import { T } from "react-translator-component";
import {
  Modal,
  Box,
  Typography,
} from "@mui/material";
import { colors } from "../../../common/colors";
import GCBackButton from "../../GreenCity/GCBackButton";
import SubmitButton from "../../SubmitButton";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PIIField from "../../GreenCity/PIIField";
import { useSelector } from "react-redux";
import { styles } from "../../../pages/styles";

// Define the props interface
interface PIIViewInfoProps {
  groupName:string;
  groupImage:any;
  open: boolean;
  onClose: () => void;
  onContinue: () => Promise<boolean>;
}

const PIIViewInfo: React.FC<PIIViewInfoProps> = ({
  groupName,
  groupImage,
  open,
  onClose,
  onContinue,
}) => {

  const { user } = useSelector((state: any) => state.userAuth);

  const handleContinue = async () => {
    onClose()
    const result = await onContinue()
    return result
  }

  return (
    <Modal open={open} onClose={onClose} sx={{zIndex: 8}}>
      <Box
        style={{
          backgroundColor: colors.farm_white,
          padding: "100px 10px 20px",
          height: "100%",
          position: "relative"
        }}
      >
        <GCBackButton onClick={onClose} />

        <Box
          style={{
            width: "100%",
            overflow: "scroll",
            padding: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <img
              alt=""
              style={{
                height: 32,
                width: 32,
                borderRadius: 18,
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: colors.farm_green500,
              }}
              src={groupImage}
            />
            <Typography style={{ fontSize: 14, fontWeight: 600 }}>
              &nbsp;{groupName}
            </Typography>
          </div>

          <br>
          </br>

          <div style={{ padding: 10 }}>
            <Typography
              style={{
                borderBottomColor: colors.farm_green150,
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                fontSize: 14,
                marginBottom: 6,
              }}
            >
              <InfoOutlinedIcon/>&nbsp;{T("pii_title")}
            </Typography>

            <div style={{ padding: "0 10px" }}>
              <PIIField fieldTitle={T("pii_nickname")} fieldData={user?.nickname} />
              <PIIField fieldTitle={T("pii_name")} fieldData={user?.name} />
            </div>
          </div>
        </Box>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            padding: "30px",
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        >
          <SubmitButton
            validate={async () => true}
            onSubmit={handleContinue}
            style={{
              ...styles.introSliderBtn,
              marginTop: "40px",
              width: "100%",
            }}
            size={"large"}
            variant="contained"
            endIcon={<ArrowForwardIosIcon
              sx={{
                position: "absolute",
                right: 0,
                top: 0,
                margin: "10px",
              }}
            />}
          >
            <span style={{ paddingRight: 30, paddingLeft: 40 }}>{T("next")}</span>
          </SubmitButton>
        </div>
      </Box>
    </Modal>
  );
};

export default PIIViewInfo;
